import { request } from '@ixicare/resources';

export type DeviceCommand =
  { action: 'reboot' } | { action: 'message'; text: string } | { action: 'find_me' } | { action: 'power_off' };

/** Queue a command for a device; a device that is not connected gets it on its next connection. */
export const sendDeviceCommand = (deviceId: number, command: DeviceCommand) =>
  request.post({
    path: `/devices/${deviceId}/commands`,
    options: { body: JSON.stringify(command) },
  });
